import { CrudConfig, TableActionType } from '../../../../model/table';
import { useStores } from '../../../store';
import { Service } from '../../../../dtos/version.dto';
import serviceService from '../../../../services/service.service';
import { ServicesUpdateDto } from '../../../../dtos/default-service-update.dto';
import { convertServiceAndStatusToCustomServiceType } from '../../../../utils/versionUtils';
import { isDuplicate } from '../../../../utils/validationUtils';
import { isEmpty } from 'lodash';
import { useMemo } from 'react';

const convertPortsToList = (fieldValue: any): string[] => {
    if (isEmpty(fieldValue) || (typeof fieldValue === 'string' && fieldValue.replace(/\s+/g, '') === '')) {
        return [];
    }
    if (typeof fieldValue === 'string') {
        const ports: string[] = fieldValue.split(',').map(port => port.replace(/\s+/g, ''));
        return ports;
    }
    return fieldValue;
};

export const useServicesCrudConfig = (): CrudConfig<Service> => {
    const { fwVersionStore, ruleStore } = useStores();

    return useMemo(() => ({
        createNewText: 'Add Service',
        entityName: 'Service',
        displayInlineActions: !!fwVersionStore.isSelectedVersionEditable,
        disableEditReason: fwVersionStore.getDisableReason,
        rowLimit: 25,
        newRecord: {
            displayName: '',
            proto: '',
            dports: '',
            sports: '',
            serviceStateInbound: '',
            serviceStateOutbound: '',
            description: ''
        },
        isDuplicated: (record: Service, originalRecord: Service | undefined, keys: string[]): boolean => {
            const defaultServices = ruleStore.defaultServicesWithStatus.map(_ =>
                convertServiceAndStatusToCustomServiceType(_));
            const allServicesData = [...ruleStore.customServices, ...defaultServices];
            return isDuplicate(record, originalRecord, allServicesData, keys);
        },
        saveCb: async (data: Service) => {
            data.dports = convertPortsToList(data.dports);
            data.sports = convertPortsToList(data.sports);
            await fwVersionStore.genericCrudMethod(serviceService.createNewCustomService, [data]);
        },
        updateCb: async (updatedRecord: Service, originalRecord: Service) => {
            if (originalRecord.isDefault) {
                await fwVersionStore.genericCrudMethod(serviceService.editDefaultService, [{
                    serviceDisplayName: updatedRecord.displayName,
                    inboundState: updatedRecord.serviceStateInbound!,
                    outboundState: updatedRecord.serviceStateOutbound!,
                } as ServicesUpdateDto]);
            } else {
                updatedRecord.dports = convertPortsToList(updatedRecord.dports);
                updatedRecord.sports = convertPortsToList(updatedRecord.sports);
                updatedRecord.serviceStateInbound = updatedRecord.serviceStateInbound!;
                updatedRecord.serviceStateOutbound = updatedRecord.serviceStateOutbound!;
                await fwVersionStore.genericCrudMethod(serviceService.updateCustomService, [updatedRecord, originalRecord.displayName]);
            }
        },
        removeCb: async (data) => {
            await fwVersionStore.genericCrudMethod(serviceService.deleteCustomService, [data.displayName]);
        },
        disable: { [TableActionType.Remove]: (data) => data.isDefault },
        dataChangesHandler: {},
        modalWidth:640,
    }), [fwVersionStore, fwVersionStore.getDisableReason, ruleStore.defaultServicesWithStatus]);
};